import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { MappingServiceInterface } from '../admin-page/mapping-service.interface';
import { JobTitleMapping } from '../models/job-title-mapping.model';

@Injectable()
export class JobTitleMappingService implements MappingServiceInterface {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/JobTitleMapping/";
    }

    async getItemsToMap(offset: number, totalItems: number, searchText: string, orderBy: string, direction: string, unmappedOnly: boolean): Promise<JobTitleMapping[]> {
        const params = new HttpParams()
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction)
            .set('unmappedOnly', unmappedOnly.toString());

        return await this._http.get<JobTitleMapping[]>(`${this.apiServer}GetJobTitleMappingInfiniteScroll`, { params: params }).toPromise<JobTitleMapping[]>();
    }

    async getUnmappedItemCount(): Promise<number> {
        return await this._http.get<number>(`${this.apiServer}GetUnmappedJobTitleCount`).toPromise<number>();
    }

    async saveMapping(mapping: JobTitleMapping) {
        return await this._http.post<JobTitleMapping>(`${this.apiServer}SaveJobTitleMapping`, JSON.stringify(mapping)).toPromise<JobTitleMapping>();
    }
}
